import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=033dfa03&scoped=true&"
import script from "./SearchComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=033dfa03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033dfa03",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesAlgoliaFlyOut: require('/var/www/packages/theme/components/molecules/AlgoliaFlyOut.vue').default,AtomsSearchBar: require('/var/www/packages/theme/components/atoms/SearchBar.vue').default,MoleculesSearchFlyOut: require('/var/www/packages/theme/components/molecules/SearchFlyOut.vue').default})
